import { render, staticRenderFns } from "./DecisionBtns.vue?vue&type=template&id=345662f2&scoped=true"
import script from "./DecisionBtns.vue?vue&type=script&lang=ts"
export * from "./DecisionBtns.vue?vue&type=script&lang=ts"
import style0 from "./DecisionBtns.vue?vue&type=style&index=0&id=345662f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345662f2",
  null
  
)

export default component.exports